import Axios, { type AxiosRequestConfig } from "axios";
import { customInstance as umbrellaCustomInstance } from "#umbrella-api-client";
import {
	clearPreviewCookie,
	getPreviewCookie,
	isPreviewCookieEnabled,
} from "#/_packages/umbrella/features/previews/utils/cookie-utils.ts";
import {
	getRequestDiagnostic,
	recordRequestDiagnostic,
} from "#/_packages/umbrella/lib/orval/request-error.ts";

// Preserve the package API through the Vite alias. The local customInstance
// overrides only the request handler; new package exports remain available.
export * from "#umbrella-api-client";

export const customInstance = async <ResponseData>(
	config: AxiosRequestConfig,
	options?: AxiosRequestConfig,
) => {
	try {
		return await umbrellaCustomInstance<ResponseData>(config, options);
	} catch (error) {
		const endpoint = new URL(options?.url ?? config.url ?? "/", "https://request.invalid").pathname;
		if (
			Axios.isAxiosError(error) &&
			error.response?.status === 401 &&
			endpoint.startsWith("/umbraco/delivery/api/") &&
			isPreviewCookieEnabled(await getPreviewCookie())
		) {
			await clearPreviewCookie();
			const diagnostic = getRequestDiagnostic(error) ?? "The CMS rejected preview access (HTTP 401).";
			recordRequestDiagnostic(
				error,
				`${diagnostic} Preview mode has been cleared. Check the CMS Delivery API preview authorization configuration.`,
			);
		}
		throw error;
	}
};